module.exports = __webpack_public_path__ + "static/media/kvinna-min.b54cf1b2.png";